import React from 'react';
import '../styles/DspShowcase.css';

const DSPs = [
  { name: 'Spotify', logo: `${process.env.PUBLIC_URL}/images/dsps/spotify-icon.svg` },
  { name: 'Apple Music', logo: `${process.env.PUBLIC_URL}/images/dsps/apple-music-icon.svg` },
  { name: 'Amazon Music', logo: `${process.env.PUBLIC_URL}/images/dsps/amazon-music-icon.svg` },
  { name: 'Tidal', logo: `${process.env.PUBLIC_URL}/images/dsps/tidal-round-black-icon.svg` },
  { name: 'YouTube Music', logo: `${process.env.PUBLIC_URL}/images/dsps/youtube-music-icon.svg` },
  { name: 'SoundCloud', logo: `${process.env.PUBLIC_URL}/images/dsps/soundcloud-logo-icon.svg` },
  { name: 'Pandora', logo: `${process.env.PUBLIC_URL}/images/dsps/pandora-icon.svg` },
  { name: 'TikTok', logo: `${process.env.PUBLIC_URL}/images/dsps/tiktok-solo-icon.svg` },
  { name: 'Instagram', logo: `${process.env.PUBLIC_URL}/images/dsps/ig-instagram-icon.svg` },
  { name: 'Facebook', logo: `${process.env.PUBLIC_URL}/images/dsps/facebook-round-color-icon.svg` },
  { name: 'Snapchat', logo: `${process.env.PUBLIC_URL}/images/dsps/snapchat-square-color-icon.svg` },
];

const DspShowcase = () => {
  return (
    <section className="dsp-showcase">
      <div className="container">
        <h2>Distribute to All Major Platforms</h2>
        <p className="section-subtitle">
          Your music deserves to be heard everywhere. We distribute to all major streaming platforms worldwide.
        </p>
        <div className="dsp-grid">
          {DSPs.map((dsp, index) => (
            <div key={index} className="dsp-item">
              <img 
                src={dsp.logo} 
                alt={dsp.name} 
                className="dsp-logo"
                loading="lazy"
              />
              <span className="dsp-name">{dsp.name}</span>
            </div>
          ))}
        </div>
        <p className="dsp-more">And many more stores worldwide</p>
      </div>
    </section>
  );
};

export default DspShowcase;
